export enum VideoType {
  YOU_TUBE = 'youtube',
  YOU_TUBE_SHORT = 'youtu.be',
  VIMEO = 'vimeo',
}
